import { render, staticRenderFns } from "./WeightConsignacion.vue?vue&type=template&id=09d4c2b4"
import script from "./WeightConsignacion.vue?vue&type=script&lang=js"
export * from "./WeightConsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports